/**
 * DynamoDBカスタマーレコード初期化ユーティリティ（サーバーAPI経由）
 */

import { api } from "~/api";

/**
 * 指定されたcustomerIdのレコードを各テーブルで初期化（サーバー側で実行）
 */
export const initializeCustomerRecords = async (customerId: string): Promise<void> => {
  try {
    console.info("Starting customer records initialization");

    const data = await api.dynamodb.initializeCustomerRecords.mutate({
      customerId,
    });

    // console.info("Customer records initialization completed:", data);

    // レスポンスデータが不正な場合のチェック
    if (!data) {
      throw new Error("カスタマーレコード初期化に失敗しました");
    }

    // 成功フラグが false の場合はエラーを投げる
    if (!data.success) {
      throw new Error(data.message || "カスタマーレコード初期化に失敗しました");
    }
  } catch (error) {
    console.error("Failed to initialize customer records:", error);
    throw error;
  }
};
